import 'reflect-metadata';
import { isNullOrEmpty } from '../../core/utils/common-functions';

const DESCRIPTION_METADATA_KEY = Symbol('Description');

/**
 * Description decorator.
 *
 * @export
 * @param {string} description
 * @return {*}  {*}
 */
export function Description(description: string): any {
  return Reflect.metadata(DESCRIPTION_METADATA_KEY, description);
}

/**
 * Get data from description decorator.
 *
 * @export
 * @param {*} target
 * @param {string} key
 * @return {*}  {*}
 */
export function getDescription(target: any, key: string): any {
  return Reflect.getMetadata(DESCRIPTION_METADATA_KEY, target, key);
}

/**
 * 取得 enum 類別的所有值
 *
 * @export
 * @param {*} enumType
 * @return {*}  {any[]}
 */
export function getEnumValues(enumType: any): any[] {
  let values: any[] = [];
  const parentType = Object.getPrototypeOf(enumType);
  if (isNullOrEmpty(parentType) === false) {
    const parentOptions = getEnumValues(parentType);
    values = values.concat(parentOptions);
  }

  Object.getOwnPropertyNames(enumType).forEach((x) => {
    const label = getDescription(enumType, x);
    if (isNullOrEmpty(label) === false) {
      values.push(enumType[x]);
    }
  });

  return values;
}

/**
 * 轉換 enum 類別為下拉選項列表
 *
 * @export
 * @param {*} enumType
 * @return {*}  {any[]}
 * @description
 * 可使用的 enum class 定義可參考 BooleanEnum，此方法將目標值 mapping 到對應 enum class 的 property 值，
 * 再將該 property 值的 description 與值轉換成 { label, value } 資料。
 */
export function convertEnumToOptions(enumType: any): any[] {
  let options: any[] = [];

  const parentType = Object.getPrototypeOf(enumType);
  if (isNullOrEmpty(parentType) === false) {
    const parentOptions = convertEnumToOptions(parentType);
    options = options.concat(parentOptions);
  }

  Object.getOwnPropertyNames(enumType).forEach((x) => {
    const label = getDescription(enumType, x);
    if (isNullOrEmpty(label) === false) {
      options.push({ label, value: enumType[x] });
    }
  });

  return options;
}
